module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignature@2x.3f12b8a.webp";